export enum INFO_SIDE {
  LEFT = 'left',
  RIGHT = 'right',
  SYMMETRIC = 'symmetric',
  LEFT_RIGHT = 'left_right',
}
